import { Injectable, inject } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { UserModel } from '../../../core/models/user/user.model';
import { cloneDeep } from 'lodash-es';
import { AuthService } from '../../../auth/auth.service';
import { Store } from '@ngrx/store';
import * as fromAuthActions from '../../../auth/state/auth.actions';

export interface UserState {
  user: UserModel | null;
}

// Component Store: This store is solely used for the user module.
@Injectable()
export class UserDetailDataStore extends ComponentStore<UserState> {
  public readonly addUser = this.updater((state: UserState, userModel: UserModel) => ({
    user: cloneDeep(userModel),
  }));

  private readonly globalStore = inject(Store);
  private readonly authService = inject(AuthService);
  constructor() {
    super({ user: null });
  }

  public readonly selectUser = () => this.select((state) => state.user);

  public readonly updateUser = (updatedUser: UserModel) => {
    this.patchState((state) => {
      updatedUser = cloneDeep(updatedUser);
      const currentUser = this.authService.getLoggedInUserClone();

      if (currentUser.id === updatedUser.id) {
        this.globalStore.dispatch(fromAuthActions.setLoggedInUser({ payload: updatedUser }));
      }
      const updatedState = cloneDeep(state);
      updatedState.user = updatedUser;
      return updatedState;
    });
  };

  public readonly reset = () => {
    this.patchState(() => {
      return { user: null };
    });
  };
}
